<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <div ref="chatContainer">
    <vue-advanced-chat
      height="calc(100vh - 20px)"
      :current-user-id="currentUserId"
      :rooms="JSON.stringify(conversations)"
      :rooms-loaded="conversationsLoaded"
      :messages="JSON.stringify(messages)"
      :messages-loaded="messagesLoaded"
      :styles="JSON.stringify(styles)"
      :show-add-room="'false'"
      :show-audio="'false'"
      :show-reaction-emojis="'false'"
      @send-message="sendMessage($event)"
      @fetch-messages="fetchMessages($event)"
    >
      <div
        slot="toggle-icon"
        class="toggle-icon"
      >
        <img
          src="/dashboard/toggleFullscreen.svg"
        >
      </div>
    </vue-advanced-chat>
  </div>
</template>

<script>
import { register } from 'vue-advanced-chat';
// import ChatConstants from '@/constants/chatHelper';
// const { SOCKET_EVENTS } = ChatConstants;


register();

const formatDate = dateString => {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) {
        return 'Invalid date';
    }
    return `${date.getDate()} ${date.toLocaleString('default', { month: 'long' })}, ${date.getFullYear()}`;
};

function generateIdFromNickname(nickname) {
    let hash = 0;
    for (let i = 0; i < nickname.length; i += 1) {
        const char = nickname.charCodeAt(i);
        hash = (hash * 32) - hash + char;
    }
    // eslint-disable-next-line no-bitwise
    hash |= 0;
    return `id_${Math.abs(hash).toString()}`;
}


const formatTimestamp = timestamp => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
};

export default {
    data() {
        return {
            currentUserNickname: '',
            currentUserId: '',
            conversations: this.$route.params.conversations || [],
            conversationsUserMap: this.$route.params.conversationsUserMap || {},
            currentConversationId: '',
            chatName: this.$route.params.chatName,
            websiteId: this.$route.params.websiteId,
            conversationsLoaded: false,
            messages: [],
            messagesLoaded: false,
            isTyping: {},
            socket: null,
            styles: {
                general: {
                    color: '#0a0a0a',
                    colorSpinner: '#333',
                    borderStyle: '1px solid #e1e4e8',
                },

                footer: {
                    background: '#f8f9fa',
                    backgroundReply: 'rgba(0, 0, 0, 0.08)',
                },
                header: {
                    position: 'fixed',
                },
                icons: {
                    search: '#9ca6af',
                    emojiReaction: 'rgba(0, 0, 0, 0.3)',
                    file: '#1976d2',
                    paperclip: '#1976d2',
                    send: '#1976d2',
                    sendDisabled: '#9ca6af',
                    emoji: '#1976d2',
                    checkmark: '#9e9e9e',
                    checkmarkSeen: '#0696c7',
                },
            },

        };
    },
    created() {
        if (this.conversations.length > 0 && Object.keys(this.conversationsUserMap).length > 0) {
            this.conversationsLoaded = true;
        } else {
            const conversationsUserMap = {};
            const response = this.$rq.getChatConversations(this.websiteId, this.chatName);
            const conversations = response.data;
            if (conversations && conversations.length > 0) {
                conversations.forEach(conversation => {
                    const firstUser = conversation.users[1];
                    conversationsUserMap[conversation.roomId] = firstUser;
                });
            }
        }
    },
    mounted() {
        this.updateHeaderWidth(2);
        window.addEventListener('resize', this.updateHeaderWidth);
        this.initializeSocket().then(() => {
            // this.listenForChatEvents();
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateHeaderWidth);
    },
    methods: {
        updateHeaderWidth(attemptsArg = 0) {
            const attemptToUpdateWidth = attempts => {
                this.$nextTick(() => {
                    const { chatContainer } = this.$refs;
                    const columnMessages = chatContainer.firstChild && chatContainer.firstChild.shadowRoot
                    && chatContainer.firstChild.shadowRoot.childNodes[1]
                    && chatContainer.firstChild.shadowRoot.childNodes[1].firstChild
                    && chatContainer.firstChild.shadowRoot.childNodes[1].firstChild.childNodes[1];

                    if (columnMessages) {
                        const headerElement = columnMessages.firstChild;
                        if (headerElement) {
                            const width = `${columnMessages.offsetWidth}px`;
                            if (width !== headerElement.style.width) {
                                document.documentElement.style.setProperty('--chat-header-width', width);
                                headerElement.style.width = width;
                            }
                        }
                    } if (attempts > 0) {
                        setTimeout(() => attemptToUpdateWidth(attempts - 1), 500);
                    }
                });
            };
            attemptToUpdateWidth(attemptsArg);
        },
        async initializeSocket() {
            // Retrieve the current user's role
            // const role = getCurrentUserRole();
            // const role = 'administrator';
            // this.socket = await this.$rq.initSocket(role);
        },

        async fetchMessages(event) {
            const conversationId = event.detail[0].room.roomId;
            const isReset = event.detail[0].options && event.detail[0].options.reset;
            if (isReset) {
                this.messages = [];
            }
            this.currentConversationId = conversationId;
            this.currentUserId = this.conversationsUserMap[conversationId];
            this.messagesLoaded = false;
            const response = await this.$rq.getChatMessages(this.websiteId, conversationId);
            const messages = response.data;
            if (isReset) {
                this.messages = messages;
            } else {
                this.messages = [...messages, ...this.messages];
            }

            this.messagesLoaded = true;
        },
        async sendMessage(event) {
            const messageObject = {
                content: event.detail[0].content,
                type: 'text',
                from: 'operator',
                origin: 'chat',
                user: {
                    nickname: this.conversationsUserMap[event.detail[0].roomId].username,
                    avatar: this.conversationsUserMap[event.detail[0].roomId].avatar,
                },

            };
            const response = await this.$rq.sendChatMessage(this.websiteId, event.detail[0].roomId, { message: messageObject });
            if (response.data.success) {
                messageObject.fingerprint = response.data.result.fingerprint;
                const nextIndexId = this.messages.length > 0 ? this.messages[this.messages.length - 1].indexId + 1 : 0;


                const formattedMessage = {
                    _id: messageObject.fingerprint.toString(),
                    indexId: nextIndexId,
                    content: messageObject.content,
                    senderId: generateIdFromNickname(messageObject.user.nickname),
                    username: messageObject.user.nickname,
                    avatar: messageObject.user.avatar,
                    date: formatDate(new Date().getTime()),
                    timestamp: formatTimestamp(new Date().getTime()),
                    saved: true,
                    distributed: true,
                    seen: false,
                    deleted: false,
                    failure: false,
                    disableReactions: true,
                };

                this.messages = [...this.messages, formattedMessage];
            }
        },
    },
};

</script>


<style lang='scss' scoped>
.toggle-icon {
  display: none;
}
@media (max-width: 900px) {
  .toggle-icon {
    display: block;
  }
}
</style>
